import type { LongevityReadinessCategory } from '../../api/longevityAssessmentApi';

/**
 * Display names for the readiness bands.
 *
 * Extracted from LongevityAssessmentsSection when the test-run rows needed the
 * same labels (Feature 118): two copies of a label map is how the client card
 * and the test run end up calling the same score different things.
 */
export const CATEGORY_LABELS: Record<LongevityReadinessCategory, string> = {
  HIGHLY_PREPARED: 'Highly Prepared',
  WELL_POSITIONED: 'Well Positioned',
  BUILDING_READINESS: 'Building Readiness',
  PLANNING_OPPORTUNITY: 'Planning Opportunity',
};
